import React from 'react'
import {CircularProgress, Button, Grid} from '@material-ui/core'
import {GridItem} from './common'
import {uploadFile} from '../../../../../../functions/project'

class ImageComponent extends React.Component {
  typoStyle = {
    0: 'headline',
    1: 'title',
    2: 'subheading',
  }

  state = {
    uploading: false,
  }

  handleUploadFile = async e => {
    const file = e.target.files[0]
    this.setState({uploading: true})
    const result = await uploadFile(this.props.project.id, file)
    this.setState({uploading: false})
    this.props.onChange(result.data.publicUrl)
  }

  handleChooseFile = () => {
    this.inputFile.click()
  }

  render() {
    // const {data = {}, depth, disabled} = this.props
    // const image = data.data
    return (
      <div>
        {/* <Typography>โลโก้ร้านค้า</Typography> */}
        <Grid container spacing={8} alignItems="center">
          {this.props.value && (
            <GridItem item xs={5}>
              <img
                alt=""
                className="rounded"
                style={{width: '300px'}}
                src={this.props.value}
              />
            </GridItem>
          )}
          <GridItem item xs={7}>
            {this.state.uploading ? (
              <CircularProgress />
            ) : (
              <div>
                <Button
                  disabled={this.props.disabled}
                  variant="contained"
                  onClick={this.handleChooseFile}
                >
                  เลือกโลโกร้านค้า
                </Button>
                <input
                  ref={input => {
                    this.inputFile = input
                  }}
                  style={{display: 'none'}}
                  type="file"
                  onChange={e => this.handleUploadFile(e)}
                />
              </div>
            )}
          </GridItem>
        </Grid>
      </div>
    )
  }
}

export default ImageComponent



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/components/ImageComponentNew.js